import React from 'react'
import LinkedinIcon from '../Icons/LinkedinIcon'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const socialMedia = [
  {
    url: 'https://www.linkedin.com/company/thegoodcode/',
    icon: LinkedinIcon
  }
]

const iconClassNames = (iconClassName) =>
  clsx('w-7 text-brand-primary lg:w-10 transition duration-300', iconClassName)

const SocialMedia = ({ iconClassName }) =>
  socialMedia.map(({ url, icon: Icon }) => (
    <a
      key={url}
      className='ml-4 first:ml-0'
      href={url}
      aria-label={`Follow us on ${url}`}
    >
      <Icon className={iconClassNames(iconClassName)} />
    </a>
  ))

export default SocialMedia

SocialMedia.propTypes = {
  iconClassName: PropTypes.string
}

SocialMedia.defaultProps = {
  iconClassName: ''
}
